import { action, batch } from '@reatom/framework'

import { pipe, Result } from '@blade/std-lib'
import { Network } from '@root/entities/network'
import { pairDtoUpdateReceivedEvent } from '@root/entities/pair'
import { ApiError, apiRequest } from '@root/shared/api'
import { tradeApiClientAtom } from '@root/shared/api/trade-api-client-atom'

import type { TypeHelper } from '@blade/std-lib'
import type { UserPositionsByDelugeIdCreatePayload } from '@blade/trade-api-client'
import type { DelugeId } from '@root/entities/user-short'

export const fetchProfilePositionsRequestAction = action(
  async (
    ctx,
    req: TypeHelper.OmitKey<
      UserPositionsByDelugeIdCreatePayload,
      'network' | 'delugeId'
    > & {
      delugeId: DelugeId
      network: Network.Network
    },
  ) => {
    const { tradeApiClient } = ctx.get(tradeApiClientAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.user.userPositionsByDelugeIdCreate, [
        {
          ...req,
          network: Network.toDto(req.network),
        },
      ]),
    )

    if (Result.isSuccess(result)) {
      batch(ctx, () => {
        for (const it of result.success.data) {
          pairDtoUpdateReceivedEvent(ctx, it.pair)
        }
      })
    }

    const mappedResult = pipe(
      result,
      Result.mapError(ApiError.fallbackToUnknown),
    )

    return mappedResult
  },
  'fetchProfilePositionsRequestAction',
)
